import { useSyncExternalStore } from 'react';

/** Whether live updates are flowing. While they are not, every screen polls every 30 seconds. */
export type LiveStatus = 'connecting' | 'open' | 'closed';

let status: LiveStatus = 'closed';
const listeners = new Set<() => void>();

export function setLiveStatus(next: LiveStatus) {
  if (next === status) return;
  status = next;
  listeners.forEach((fn) => fn());
}

export function liveIsUp() {
  return status === 'open';
}

export function useLiveStatus(): LiveStatus {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => status,
  );
}
